import React from "react";
import { FaPhone, FaEnvelope, FaMapMarkedAlt, FaMobileAlt } from "react-icons/fa";
import "./contact.css";

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      {/* Header Section */}
      <div className="contact-header">
        <div className="contact-header2">
          <div className="contact-iconmain">
            <FaMobileAlt size={32} color="#12233d" />
          </div>
          
        </div>
        <h2>Let's Get Started</h2>
        <p>Have a project in mind? Contact us today for a free consultation.</p>
      </div>

      {/* Contact Boxes */}
      <div className="contact-container">
        <div className="contact-box">
          <div className="contact-icon">
            <FaMapMarkedAlt size={24} color="#ff7f00" />
          </div>
          <h3>OUR MAIN OFFICE</h3>
          <p>Adama Minch Market Center. G+4 Office No.12</p>
        </div>

        <div className="contact-box">
          <div className="contact-icon">
            <FaPhone size={24} color="#ff7f00" />
          </div>
          <h3>PHONE NUMBER</h3>
          <p>
            +251904803380
            
          </p>
          <p>
            +251902340084
            
          </p>
        </div>

        <div className="contact-box">
          <div className="contact-icon">
            <FaEnvelope size={24} color="#ff7f00" />
          </div>
          <h3>EMAIL</h3>
          <p>
            <a href="mailto:info@iklimdigitals.com">info@iklimdigitals.com</a>
          </p>
        </div>
      </div>
      <div className="map-content">
    <h2 className="map-title">Our Location</h2>
    <p className="map-subtitle">
      Visit us at Mebrat Hail — easily accessible and right in front of Awash Bank.
    </p>

    <div className="map-wrapper">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3858.1758254886786!2d39.2706158!3d8.546714300000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b1f00488f0c17%3A0x9929ac953d35ab4e!2sIklim%20digitals%20PLC!5e1!3m2!1sen!2set!4v1758026373448!5m2!1sen!2set"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ border: 0 }}
        title="Iklim Digitals Location"
      ></iframe>
    </div>
  </div>
    </section>
    
  );
};

export default Contact;
